export default __webpack_public_path__ + "static/media/pic13.cfb147ce.jpg";